import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Banner, Error, Spinner } from '../../../../components';
import { useGetCityDocumentFromFirestore, useQueryHelper } from '../../../../queries';

interface CityProps {
  id: string;
}

export const City: FC<CityProps> = ({ id }) => {
  const cityDocument = useGetCityDocumentFromFirestore(id || '');
  const { data: cityData, refetch } = cityDocument;
  const { isLoading, isError } = useQueryHelper({
    queries: [
      cityDocument],
  });
  const navigate = useNavigate();

  if (isLoading) {
    return <Spinner global />;
  }
  if (isError) {
    return (<Error errorMessage="Bład pobierania miasta" action={refetch} />);
  }

  return (
    <Banner
      image={cityData?.coverPhoto || ''}
      title={`Odkryj ${cityData?.name}`}
      height="200px"
      action={() => navigate('/city')}
      key="city-banner"
    />
  );
};
